"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTimer = void 0;
var _react = require("react");
// timer for single execution
const useTimer = () => {
  const timerRef = (0, _react.useRef)();
  const startTimeRef = (0, _react.useRef)(0);
  const remainingTimeRef = (0, _react.useRef)(0);
  const callbackRef = (0, _react.useRef)();
  const isPausedRef = (0, _react.useRef)(false);
  const clear = (0, _react.useCallback)(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
      isPausedRef.current = false;
    }
  }, []);
  const start = (0, _react.useCallback)((callback, duration) => {
    // clear existing timer
    clear();
    timerRef.current = setTimeout(callback, duration);
    callbackRef.current = callback;
    startTimeRef.current = new Date().getTime();
    remainingTimeRef.current = duration;
  }, [clear]);
  const pause = (0, _react.useCallback)(() => {
    if (!isPausedRef.current) {
      const currentTime = new Date().getTime();
      clear();
      remainingTimeRef.current -= currentTime - startTimeRef.current;
      isPausedRef.current = true;
    }
    return remainingTimeRef.current;
  }, [clear]);
  const resume = (0, _react.useCallback)(() => {
    if (callbackRef.current && isPausedRef.current) {
      start(callbackRef.current, remainingTimeRef.current);
      isPausedRef.current = false;
    }
  }, [start]);
  (0, _react.useEffect)(() => {
    return () => {
      clear();
    };
  }, [clear]);
  return (0, _react.useMemo)(() => ({
    start,
    clear,
    pause,
    resume
  }), [start, clear, pause, resume]);
};
exports.useTimer = useTimer;